import React from "react";
import AmtAttach from "./components/AmtAttach";
import ContextEdit from "./components/ContextEdit";
import Faq from "./components/Faq";
import PlanCards from "./components/PlanCards";
import WhyBook from "./components/WhyBook";

export const CONTEXT_EDIT_ID = "COMPONENT_LISTING_PAGE_CONTEXT_EDIT";
export const PLAN_CARDS_ID = "COMPONENT_LISTING_PAGE_DT_PLAN_CARDS";
export const AMT_ATTACH_ID = "COMPONENT_LISTING_PAGE_AMT_ATTACH";
export const WHY_BOOK_ID = "COMPONENT_LISTING_PAGE_WHY_BOOK";
export const FAQ_ID = "COMPONENT_LISTING_PAGE_FAQ";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const REVAMP_COMPONENT_MAPPER: Record<
  string,
  React.ComponentType<any>
> = {
  [CONTEXT_EDIT_ID]: ContextEdit,
  [PLAN_CARDS_ID]: PlanCards,
  [AMT_ATTACH_ID]: AmtAttach,
  [WHY_BOOK_ID]: WhyBook,
  [FAQ_ID]: Faq,
  // Future:
  // COMPONENT_LISTING_PAGE_CAROUSEL_PERSUASION
};
